import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CommonModule} from '@angular/common';
import {RouteReuseStrategy} from '@angular/router';

import {IonicModule, IonicRouteStrategy} from '@ionic/angular';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {HttpClientModule} from '@angular/common/http';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

// import app pages
import {PhonebookPage} from './pages/phonebook/phonebook.page';
import {HomePage} from './pages/home/home.page';
import {HipastatusPage} from './pages/accelerators/hipastatus/hipastatus.page';
import {ProscanstatusPage} from './pages/accelerators/proscanstatus/proscanstatus.page';
import {SlsstatusPage} from './pages/accelerators/slsstatus/slsstatus.page';
import {SwissfelstatusPage} from './pages/accelerators/swissfelstatus/swissfelstatus.page';
import {MapPage} from './pages/map/map.page';
import {PublicTransportPage} from './pages/public-transport/public-transport.page';
import {InfoPage} from './pages/infopage/infopage.page';
import {HighlightsPage} from './pages/highlights/highlights.page';
import {ZptPlansPage} from './pages/zpt/zpt-plans/zpt-plans.page';
import {ZptContactsPage} from './pages/zpt/zpt-contacts/zpt-contacts.page';
import {ProfileModalPage} from './components/profile-modal/profile-modal.page';
import {OasemenuPage} from './pages/oasemenu/oasemenu.page';
import {FoodmarketPage} from './pages/foodmarket/foodmarket.page';
import {PiaCulinaarePage} from './pages/pia-culinaare/pia-culinaare.page';


// external libraries
import {PinchZoomModule} from '@meddv/ngx-pinch-zoom';
import {NgxEchartsModule} from 'ngx-echarts';

import { RecyclingPage } from './pages/recycling/recycling.page';
import { MobileNavComponent } from './components/mobile-nav/mobile-nav.component';
import { MobileMenuComponent } from './components/mobile-menu/mobile-menu.component';
import { MobileMenuPopoverComponent } from './components/mobile-menu-popover/mobile-menu-popover.component';

@NgModule({
    declarations: [
        AppComponent,
        PublicTransportPage,
        HomePage,
        HipastatusPage,
        ProscanstatusPage,
        SlsstatusPage,
        SwissfelstatusPage,
        MapPage,
        PhonebookPage,
        InfoPage,
        HighlightsPage,
        ZptPlansPage,
        ZptContactsPage,
        ProfileModalPage,
        OasemenuPage,
        FoodmarketPage,
        PiaCulinaarePage,
        RecyclingPage,
        MobileNavComponent,
        MobileMenuComponent,
        MobileMenuPopoverComponent
    ],
    imports: [
        AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        FormsModule,
        HttpClientModule,
        IonicModule.forRoot(),
        PinchZoomModule,
        NgxEchartsModule.forRoot({
            echarts: () => import('echarts'),
        }),
        ReactiveFormsModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
    ],
    providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
